// Aurora Promise campaign (17–31 Jul 2026).
// Promotional mechanic: book an eligible Aurora expedition during the campaign
// window and, if there is no confirmed Aurora sighting for the entire trip, 50%
// of the land tour package price is refunded in SoCredits. All giveaway/seminar
// mechanics from the previous (Taiwan-only) aurora campaign have been removed.

// Campaign booking window — surfaced in the promises note and FAQ copy.
export const AURORA_CAMPAIGN_WINDOW = "17–31 Jul 2026";

// Destination spotlight cards — render above the live trips grid. Decoupled from
// `promotions.filter_trips` so the 4-card vision ships even while ops attaches
// inventory to the campaign. A card links straight to its project page whenever
// `projectId` exists; live availability strips (dates/price) only render when the
// campaign trips API returns trips for that project.
export const AURORA_DESTINATIONS = [
  {
    key: "canada",
    projectId: 713,
    status: "available",
    image:
      "https://d1puf2nnbcyl9q.cloudfront.net/2026-06-15T09:49:46.539ZWinter-Aurora-Teepee_-Kwon-O-Chul.jpg",
  },
  {
    key: "norway",
    projectId: 159,
    status: "available",
    image:
      "https://d1puf2nnbcyl9q.cloudfront.net/2026-07-24T05:33:35.711Z2025-11-30T13_57_02.311ZIMG_5429.jpeg",
  },
  {
    key: "sweden",
    projectId: 561,
    status: "available",
    image:
      "https://d1puf2nnbcyl9q.cloudfront.net/2025-12-11T04:06:34.042Zicebreaker2.webp",
  },
  {
    key: "iceland",
    projectId: 320,
    status: "available",
    image:
      "https://d1puf2nnbcyl9q.cloudfront.net/2025-11-25T05:07:08.382Zkatlatrack_tours_Katla_5.jpeg",
  },
];
